import { HestiaApp } from 'data/terra/api/terra/response/HestiaAppsResponse';
import { PandoraConfig } from 'data/terra/api/terra/response/PandoraConfigResponse';
import { cloneDeep } from 'lodash';
import { AESDecrypt } from './crypto';

export function decryptPandoraConfig(rawConfig: any, clientId: string): any {
  if (rawConfig.serviceConfigs) {
    return decryptPandoraConfigLegacy(rawConfig, clientId);
  } else {
    return decryptPandoraConfigNew(rawConfig, clientId);
  }
}

export function decryptPandoraConfigNew(
  rawConfig: PandoraConfig,
  clientId: string
): any {
  const decryptKey = getKey(clientId);
  const result: any = cloneDeep(rawConfig);
  for (const i in result.services) {
    const source = result.services[i].config;
    const decrypted = AESDecrypt(source, decryptKey);

    result.services[i].config = JSON.parse(decrypted);
  }

  const appConfigDecrypt = AESDecrypt(result.config, decryptKey);
  result.config = JSON.parse(appConfigDecrypt);

  return result;
}

export function decryptPandoraConfigLegacy(
  rawConfig: any,
  clientId: string
): any {
  const decryptKey = getKey(clientId);
  const result: any = cloneDeep(rawConfig);
  for (const i in result.serviceConfigs) {
    const source = result.serviceConfigs[i].config;
    if (source) {
      const decrypted = AESDecrypt(source, decryptKey);
      result.serviceConfigs[i].config = JSON.parse(decrypted);
    }
  }

  return result;
}

export function decryptHestiaApp(rawConfig: HestiaApp, clientId: string): any {
  const decryptKey = getKey(clientId);
  const result: any = cloneDeep(rawConfig);
  const decrypted = AESDecrypt(result.config, decryptKey);
  result.config = JSON.parse(decrypted);
  return result;
}

function getKey(clientId: string): string {
  const keyLength = 32;
  const additional = 'abcdefghijklmnopqrstuvwxyz';
  const encode = window.btoa(clientId);
  const first32 = encode.slice(0, keyLength);

  if (first32.length < keyLength) {
    return `${first32}${additional.slice(0, keyLength - first32.length)}`;
  } else {
    return first32;
  }
}
